class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.handleVariantChange = this.handleVariantChange.bind(this);
    this.onSwatchChange = this.onSwatchChange.bind(this);
  }

  connectedCallback() {
    this.init();
    window.addEventListener('product:swatch-change', this.onSwatchChange);
  }

  disconnectedCallback() {
    window.removeEventListener('product:swatch-change', this.onSwatchChange);
    if (this.selectors) {
      this.selectors.forEach(selector => {
        selector.removeEventListener('change', this.handleVariantChange);
      });
    }
  }

  onSwatchChange(event) {
    const productForm = this.closest('product-form-component')?.querySelector('form');
    const ourFormId = productForm?.id || null;
    if (event.detail.productFormId == null || event.detail.productFormId !== ourFormId) {
      return;
    }

    this.handleVariantChange(null, false, +event.detail.variantId);
  }

  init() {
    this.options = {
      isQuickShop: false,
      isPreorder: false,
    };
    if (this?.dataset?.options) {
      const dataOptions = JSON.parse(this.dataset.options);
      this.options = {
        ...this.options,
        ...dataOptions,
      };
    }

    const currentVariantId = parseInt(this.closest('product-form-component').querySelector('input[name="id"]').value);
    this.selectedVariant = this.getCurrentVariant(currentVariantId);
    this.previousColorOption = this.selectedVariant.options.length == 3 ? this.selectedVariant.option2 : this.selectedVariant.option1;

    if (this.selectors) {
      this.selectors.forEach(selector => {
        selector.removeEventListener('change', this.handleVariantChange);
      });
    }

    this.selectors = this.querySelectorAll('input[type="radio"]');
    this.selectors.forEach(selector => {
      selector.addEventListener('change', this.handleVariantChange);
    });

    this.kitSlider = document.querySelector('[data-kit-slider]');
  }

  getCurrentVariant(id) {
    return this.getVariantData().find(variant => variant.id === +id);
  }

  handleVariantChange(event, initFirst = false, id = null) {
    if (initFirst) {
      this.init();
      this.variantId = this.selectedVariant.id;
    }
    else if (id || event) {
      this.variantId = event ? event.target.value : id ? id : null;
    }

    if (this.variantId) {
      this.newVariant = this.getCurrentVariant(this.variantId);

      if (this.options.isQuickShop) {
        this.fetchProductInfo();
      }
      else {
        this.renderProductInfoFromSection();
      }
    }
  }

  fetchProductInfo() {
    const url = `${this.options.url}?variant=${this.variantId}&section_id=theme-quick-shop`;

    fetch(url)
      .then(response => {
        return response.text();
      })
      .then(data => {
        const html = new DOMParser().parseFromString(data, 'text/html');
        const productForm = this.closest('product-form-component');

        productForm.querySelector('[data-quick-shop-options-wrapper]').innerHTML = html.getElementById('shopify-section-theme-quick-shop').innerHTML;
      })
      .catch(error => {
        if (error.name !== 'AbortError') {
          console.error('Error fetching product info:', error);
        }
      });
  }

  renderProductInfoFromSection() {
    const url = `${this.options.url}?variant=${this.variantId}&section_id=${this.options.section}`;
    fetch(url)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        const productInfo = document.querySelector('[data-product-info]');
        if (html.querySelector('[data-product-info]')) {
          productInfo.innerHTML = html.querySelector('[data-product-info]').innerHTML;
        }

        if (this.kitSlider) {
          const currentColorOption = this.newVariant.options.length === 3 ? this.newVariant.option2 : this.newVariant.option1;
          const colorHasChanged = this.previousColorOption !== currentColorOption;

          if (colorHasChanged) {
            this.updateKitSlider();
          }
        }

        this.updateURL(url);
        this.dispatchVariantChange(this.newVariant.id);
      });
  }

  updateKitSlider() {
    const url = `${this.options.url}?variant=${this.variantId}&section_id=theme-kit-content`;
    fetch(url)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        if (html) {
          const swiperEl = html.getElementById('shopify-section-theme-kit-content');
          const newSlides = swiperEl.querySelectorAll('.swiper-slide');
          if (!swiperEl || !newSlides) return;

          this.kitSlider.swiper.destroy();
          this.kitSlider.querySelector('.swiper-wrapper').innerHTML = '';
          newSlides.forEach(slide => {
            this.kitSlider.querySelector('.swiper-wrapper').append(slide);
          });
          this.kitSlider.closest('swiper-slider').init();
          this.kitSlider.swiper.update();
        }
      });
  }

  dispatchVariantChange(variantId) {
    document.dispatchEvent(
      new CustomEvent('product:variant-change', {
        bubbles: true,
        detail: {
          variantId,
        },
      }),
    );
  }

  updateURL(url) {
    const newUrl = new URL(url, window.location.origin);
    newUrl.searchParams.delete('section_id');
    window.history.pushState({}, '', newUrl.toString());
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

if (!customElements.get('variant-radios')) {
  customElements.define('variant-radios', VariantRadios);
}